// Shared by the offer stash and the freeze intent: the pending resume state
// must not outlive a plausible sign-in roundtrip.
export const DF_RESUME_STORAGE_TTL_MS = 30 * 60 * 1000
